<template>
    <h6 :class="className" :style="styleh6">
        {{ title }} <span
        v-if="! locked"
        :style="style"
        data-height="12px"
        class="iconify mb-2 mx-1"
        data-icon="bi:info-circle"
        data-inline="false"
        role="button"
        tabindex="0"
        :data-bs-toggle="locked ? '' : 'popover'"
        data-bs-trigger="focus"
        :data-bs-content="content"
    >
    </span>: <span :style="valueStyle">{{ val || defaultTitle }}</span>
    </h6>
</template>

<script>
export default {
    name: 'InfoBox',
    props: {
        className: { default: ''},
        style: { default: 'color: black'},
        valueStyle: { default: ''},
        styleh6: { default: ''},
        locked: { default: false},
        title: { required: true},
        val: { required: true },
        content: { required: true },
        defaultTitle: { default: 'N/A' }
    }
}
</script>
